import deepCamelizeKeys from "../../../../utils/object/deepCamelizeKeys.js";
import { API_HOST_NAME } from "../constants.js";
import { has } from 'lodash';

const URL = `${API_HOST_NAME}/api/v1/auth/check_login_confirmation`;

const useCheckLoginConfirmation = () => {

  const check = (confirmationToken) => {
    return fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        confirmation: {
          confirmation_token: confirmationToken,
        }
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          return Promise.reject(new Error('Confirmation expired'))
        }
        return response.json()
      })
      .then((data) => {
        const body = deepCamelizeKeys(data)

        if (has(body, 'token')) {
          return { type: 'token', token: body.token }
        }
        if (has(body, 'status') && body.status === 'pending') {
          return { type: 'pending' }
        }
        return Promise.reject(new Error('Unknown response format'))
      })
  }

  return { check };
};

export default useCheckLoginConfirmation;
